import { Box, ButtonBase, Divider, FormControlLabel, Menu, MenuItem, Radio, RadioGroup } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import SearchIcon from "../../assets/images/searchIcon.svg";
import sortIcon from "../../assets/images/sortIcon.svg";
import userIcon from "../../assets/images/userIcon.svg";
import { useStyles } from "../../assets/jss/DriverLocatorSidebar";
import DateTime from "../DateTime/DateTime";
import { DriverState, SortListBy, SortListOrder } from "../../config/app-globals.enum";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomIconButton from "../CustomComponents/CustomIconButton/CustomIconButton";
import CustomInputAdornment from "../CustomComponents/CustomInputAdornment/CustomInputAdornment";
import CustomTextField from "../CustomComponents/CustomTextField/CustomTextField";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";

function DriverLocatorSidebar(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);

    /* const filterSortBy = [
        { title: t("Driver Name"), value: SortListBy.DRIVERNAME },
        { title: t("Date & Time"), value: SortListBy.DATENTIME },
    ]; */

    const sortByDriverName = [
        { title: t("Ascending"), value: SortListOrder.ASC },
        { title: t("Descending"), value: SortListOrder.DESC },
        { title: t("Ascending"), value: SortListOrder.DATE_ASC },
        { title: t("Descending"), value: SortListOrder.DATE_DESC },
    ];

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (event) => {
        setAnchorEl(null);
    };

    /**
     *
     * @param {number} driveState
     * @returns
     */
    function getClassNameByDriveState(driveState) {
        if (driveState === DriverState.MOVING) {
            return classes.driverListItemIconMoving;
        } else if (driveState === DriverState.PARKED) {
            return classes.driverListItemIconParked;
        }
        return "";
    }

    return (
        <>
            <CustomBox className={classes.driverListBoxContainer}>
                <CustomBox className={classes.searchBox}>
                    <CustomTypography
                        component="div"
                        variant="caption"
                        className={classes.headerTitle}
                    >
                        {t("DRIVER_LOCATOR")}
                    </CustomTypography>
                    <CustomBox className={classes.sideBarSearchView}>
                        <CustomTextField
                            placeholder={t("SEARCH_DRIVER")}
                            fullWidth
                            className={classes.search}
                            InputProps={{
                                startAdornment: (
                                    <CustomInputAdornment position='start'>
                                        <CustomIconButton style={{ padding: 8 }}>
                                            <img
                                                src={SearchIcon}
                                                alt="Search"
                                                className={classes.searchIcon}
                                            />
                                        </CustomIconButton>
                                    </CustomInputAdornment>
                                ),
                            }}
                            value={props.searchKey}
                            onChange={props.handleSearch}
                        />
                        {/* <CustomIconButton className={classes.filterIcon} onClick={() => setOpenReport(true)} >*/}
                        <CustomIconButton
                            className={classes.filterIcon}
                            aria-controls="sort-menu"
                            aria-haspopup="true"
                            onClick={handleMenuClick}
                        >
                            <img src={sortIcon} height={24} width={24} />
                        </CustomIconButton>
                        <Menu
                            id="sort-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "center" }}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            <CustomBox className={classes.sortByMenuBox}>&nbsp;</CustomBox>
                            <CustomBox className={classes.sortByMenuHeader}>
                                {t("SORT_BY")}
                            </CustomBox>
                            <CustomBox className={classes.sortByMenuSubHeader}>
                                {t("DRIVER_NAME")}
                            </CustomBox>
                            <RadioGroup name="sortByNameAsc">
                                <FormControlLabel value={SortListOrder.ASC} control={
                                    (<MenuItem
                                        onClick={(event) => [
                                            props.setSelectedSortByFilter(SortListOrder.ASC),
                                            handleMenuClose(event),
                                        ]}
                                    >
                                        <CustomBox className={classes.sortByMenuItem}>
                                            <CustomBox className={clsx(
                                                classes.sortByMenuItemRadio,
                                                SortListOrder.ASC ===
                                                    props.selectedSortByFilter
                                                    ? classes.sortByMenuItemRadioSelected
                                                    : "")}></CustomBox>
                                            <CustomBox className={classes.sortByMenuItemText}>
                                                {sortByDriverName[0].title}
                                            </CustomBox>
                                        </CustomBox>
                                    </MenuItem>)
                                } label="" />
                                <FormControlLabel value={SortListOrder.DESC} control={
                                    (<MenuItem
                                        onClick={(event) => [
                                            props.setSelectedSortByFilter(SortListOrder.DESC),
                                            handleMenuClose(event),
                                        ]}
                                    >
                                        <CustomBox className={classes.sortByMenuItem}>
                                            <CustomBox className={clsx(
                                                classes.sortByMenuItemRadio,
                                                SortListOrder.DESC ===
                                                    props.selectedSortByFilter
                                                    ? classes.sortByMenuItemRadioSelected
                                                    : "")}></CustomBox>
                                            <CustomBox className={classes.sortByMenuItemText}>
                                                {sortByDriverName[1].title}
                                            </CustomBox>
                                        </CustomBox>
                                    </MenuItem>)
                                } label="" />
                                <CustomBox className={classes.sortByMenuSubHeader}>
                                    {t("DATE_&_TIME")}
                                </CustomBox>
                                <FormControlLabel value={SortListOrder.DATE_ASC} control={
                                    (<MenuItem
                                        onClick={(event) => [
                                            props.setSelectedSortByFilter(SortListOrder.DATE_ASC),
                                            handleMenuClose(event),
                                        ]}
                                    >
                                        <CustomBox className={classes.sortByMenuItem}>
                                            <CustomBox className={clsx(
                                                classes.sortByMenuItemRadio,
                                                SortListOrder.DATE_ASC ===
                                                    props.selectedSortByFilter
                                                    ? classes.sortByMenuItemRadioSelected
                                                    : "")}></CustomBox>
                                            <CustomBox className={classes.sortByMenuItemText}>
                                                {sortByDriverName[2].title}
                                            </CustomBox>
                                        </CustomBox>
                                    </MenuItem>)
                                } label="" />
                                <FormControlLabel value={SortListOrder.DATE_DESC} control={
                                    (<MenuItem
                                        onClick={(event) => [
                                            props.setSelectedSortByFilter(SortListOrder.DATE_DESC),
                                            handleMenuClose(event),
                                        ]}
                                    >
                                        <CustomBox className={classes.sortByMenuItem}>
                                            <CustomBox className={clsx(
                                                classes.sortByMenuItemRadio,
                                                SortListOrder.DATE_DESC ===
                                                    props.selectedSortByFilter
                                                    ? classes.sortByMenuItemRadioSelected
                                                    : "")}></CustomBox>
                                            <CustomBox className={classes.sortByMenuItemText}>
                                                {sortByDriverName[3].title}
                                            </CustomBox>
                                        </CustomBox>
                                    </MenuItem>)
                                } label="" />
                            </RadioGroup>
                            <CustomBox className={classes.sortByMenuBox}>&nbsp;</CustomBox>
                        </Menu>
                    </CustomBox>
                </CustomBox>
                {props.isApi ? (
                    <CustomPaper elevation={0} square style={{ padding: "2em" }}>
                        <CustomCircularProgress
                            className={classes.driverLocatorSidebarLoader}
                        />
                    </CustomPaper>
                ) : (
                    <CustomBox className={classes.driverListBox}>
                        {props.filteredDriverList && props.filteredDriverList.length ? (
                            props.filteredDriverList.map((data, index) => {
                                return (
                                    <CustomBox
                                        key={index}
                                        onClick={() => { props.setSelectedDriver(data); props.setIsDriverPopupClosed(false) }}
                                    >
                                        <ButtonBase
                                            component="div"
                                            className={clsx(
                                                classes.driverListItem,
                                                data.userId ===
                                                    (props.selectedDriver && props.selectedDriver.userId)
                                                    ? classes.driverListItemSelected
                                                    : ""
                                            )}
                                        >
                                            <CustomBox className={classes.driverListItemIconBox}>
                                                <CustomBox
                                                    className={clsx(
                                                        classes.driverListItemIcon,
                                                        getClassNameByDriveState(data.driveState)
                                                    )}
                                                >
                                                    <img alt="" src={userIcon} />
                                                </CustomBox>
                                            </CustomBox>
                                            <CustomBox className={classes.driverListItemSideBox}>
                                                <CustomBox className={classes.driverName}>
                                                    {data.firstName.trim()}&nbsp;{data.lastName.trim()}
                                                </CustomBox>
                                                {data.driveStateDate !== undefined && data.driveStateDate !== null &&
                                                    <CustomBox className={classes.stateDate}>
                                                        <DateTime
                                                            inputDate={data.driveStateDate}
                                                            returnFormat="DD MMM YYYY"
                                                        />{" "}
                                                        |{" "}
                                                        <DateTime
                                                            inputDate={data.driveStateDate}
                                                            returnFormat="hh:mm A"
                                                        />
                                                    </CustomBox>
                                                }
                                            </CustomBox>
                                        </ButtonBase>
                                        {/* <Divider light /> */}
                                    </CustomBox>
                                );
                            })
                        ) : (
                            <CustomTypography
                                component="div"
                                variant="caption"
                                className={classes.driverLocatorSidebarNoRecordText}
                            >
                                {t("NO_RECORDS_FOUND")}
                            </CustomTypography>
                        )}
                    </CustomBox>
                )}
            </CustomBox>
        </>
    );
}

export default DriverLocatorSidebar;
